import { drugCategoryActions } from '../../../../redux/actions/medication/drugs/drugs';

// Initial state for category management
const initialState = {
  categories: [], // List of drug categories
  loading: false, // Loading state indicator
  error: null // Error information, if any
};

/**
 * Reducer for handling drug category actions.
 * @param {Object} state - Current state of the reducer.
 * @param {Object} action - Dispatched action containing type and payload.
 * @returns {Object} - Updated state based on action type.
 */
const categoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case drugCategoryActions.FETCH_CATEGORIES.REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case drugCategoryActions.FETCH_CATEGORIES.SUCCESS:
      return {
        ...state,
        loading: false,
        categories: action.payload
      };

    case drugCategoryActions.FETCH_CATEGORIES.FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
};

export default categoryReducer;
